import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { useForceUpdatePresenter } from './ForceUpdate.presenter';
import styles from './ForceUpdate.style.m.css';

export const ForceUpdate: FC = observer(() => {
  const presenter = useForceUpdatePresenter();
  const { t } = useTranslation();

  //ToDo move to infoblock

  const image = getMascotImageSrc(PROJECT_CONFIG.imageAssets.newVersion);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          {image && (
            <img
              src={image}
              width={189}
              height={176}
              alt={''}
            />
          )}
        </div>
        <div className={styles.title}>{t('forced_update_os_min_supp_version_headline')}</div>
        <div className={styles.description}>{t('force_upgrade_text')}</div>
        <div className={styles.button}>
          <Button
            theme="primary"
            onClick={presenter.handleUpdate}
          >
            {t('force_upgrade_update_button_title')}
          </Button>
        </div>
      </div>
    </div>
  );
});
